import React from "react";

import "./confirmation-bar.css";

export const ConfirmationBar = ({
	left,
	title,
	right,
	className,
}: {
	className?: string;
	left?: React.ReactNode;
	title?: string;
	right?: React.ReactNode;
}) => (
	<div className={`confirmation-bar ${className || ""}`}>
		<div className="confirmation-bar__left">{left}</div>

		<div className="confirmation-bar__title">{title}</div>

		<div className="confirmation-bar__right">{right}</div>
	</div>
);
ConfirmationBar.displayName = "ConfirmationBar";
